import { useEffect } from "react";
import { Control as olControl } from "ol/control";
import { renderToString } from "react-dom/server";

const Control = ({ className, map, onMount, clickHandler = () => {}, children }) => {

    const element = document.createElement("div");
    element.setAttribute("class", className + " ol-unselectable ol-control");
    element.onclick = (e) => clickHandler(e)

    useEffect(() => {
        if (!map) return;
        const tehcontrol = new olControl({
            element,
            render: () => {
                try {
                    if(onMount){
                        onMount(tehcontrol)
                    }else{
                        element.innerHTML = renderToString(children);
                    }
                    // onMount(tehcontrol)
                } catch (err) {}
            },
        });
        map.controls.push(tehcontrol);
        if(onMount) onMount(tehcontrol)
        return () => map.controls.remove(tehcontrol);
    }, [map]);

    return null;
};
export default Control;
